import { render, staticRenderFns } from "./SelectModel.vue?vue&type=template&id=fd18c2ca&"
import script from "./SelectModel.vue?vue&type=script&lang=js&"
export * from "./SelectModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports